import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { get, map, filter, includes } from "lodash";

import Box from "@material-ui/core/Box";
import MenuList from "@material-ui/core/MenuList";

import MenuElement from "./MenuElement";
import MenuElementWithSubMenu from "./MenuElementWithSubMenu";

import { sideBarMenu as menu } from "../../constants/menus";

import colors from "../../assets/style/colors";
import { isAllowed } from "../../utils/users";
import MenuElementDynamic from "./MenuElementDynamic";

const styles = {
  sidebar: {
    width: "65px",
    minHeight: "calc(100vh - 50px)",
    backgroundColor: colors.white,
    boxShadow: `0px 2px 10px 2px ${colors.black23}`,

    '@media(max-width: 470px)' : {
      display: "none",
    }
  },
  menuList: {
    paddingTop: 4,
    "&:focus": {
      outline: "none",
    },
  },
};

const SideBar = (props) => {
  const { classes, /*breadcrumb,*/ solutionsAccess, permissions } = props;

  let activeSection = "";
  // Disable Highlight
  // if (breadcrumb && breadcrumb.path) {
  //   activeSection = breadcrumb.path.join("/");
  // }
  // // new breadcrumb
  // if (
  //   get(breadcrumb, ["path", 0]) &&
  //   typeof get(breadcrumb, ["path", 0]) === "object"
  // ) {
  //   activeSection = map(get(breadcrumb, ["path"]), (b) =>
  //     get(b, ["name"])
  //   ).join("/");
  // }
  // if (activeSection === "home") activeSection = "";

  const level = get(props, ["userRole", "level"]);

  return (
    <Box className={classes.sidebar}>
      <MenuList classes={{ root: classes.menuList }}>
        {map(
          filter(
            menu,
            (item) =>
              level <= item.enabled &&
              (!item.restrict ||
                get(solutionsAccess, [item.restrict, "allow"])) &&
              (!item.permission || isAllowed(permissions, item.permission))
          ),
          (item) =>
            item.subMenu === "dynamic" ? (
              <MenuElementDynamic
                key={item.name}
                item={item}
                solutionsAccess={solutionsAccess}
                userLevel={level}
                permissions={permissions}
                id={item.name}
              />
            ) : item.subMenu === true ? (
              <MenuElementWithSubMenu
                item={item}
                key={item.name}
                active={includes(activeSection, item.name)}
                solutionsAccess={solutionsAccess}
                userLevel={level}
                permissions={permissions}
                id={item.name}
              />
            ) : (
              <MenuElement
                item={item}
                key={item.name}
                active={includes(activeSection, item.name)}
              />
            )
        )}
      </MenuList>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    breadcrumb: get(state, ["common", "breadcrumb"]),
    userRole: get(state, ["user", "role"]),
    solutionsAccess: get(state, ["user", "solutionsAccess"]),
    permissions: get(state, ["user", "permissions"]),
  };
};

export default connect(mapStateToProps)(withStyles(styles)(SideBar));
